import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB1dQoG9Rv2lghX1v1GJOL8wcd9mc_mu8",
  authDomain: "blackbird-d85d3.firebaseapp.com",
  databaseURL: "https://blackbird-d85d3-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "blackbird-d85d3",
  storageBucket: "blackbird-d85d3.appspot.com",
  messagingSenderId: "392641216202",
  appId: "1:392641216202:web:2cf64b448eaa8fb76d7e33",
  measurementId: "G-35SZEPH3Y5"
};

// Initialisation de Firebase
const app = initializeApp(firebaseConfig);

// Initialisation des services Firebase
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
